import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchQuickPayMasterProduct } from '@/services/quickPay';
import {
  IApiResponse,
  ICreateQuickPayMasterProduct,
  IDeleteQuickPayMasterProduct,
} from '../sagas/quickPaySaga';
import { QuickPayMasterProduct } from '../types';

export interface QuickPayMasterProductState {
  quickPayMasterProducts: IApiResponse;
  quickPayMasterProduct: QuickPayMasterProduct;
  loading: boolean;
  error: boolean;
}

export const initialState: QuickPayMasterProductState = {
  loading: false,
  error: false,
  quickPayMasterProducts: {
    data: [],
    pagination: {
      totalRecords: 0,
      currentPage: 0,
      totalPages: 0,
      nextPage: 0,
      previousPage: 0,
    },
    success: false,
    message: '',
  },
  quickPayMasterProduct: {
    productId: '',
    pepsiProductId: '',
    barcodes: [],
    createdOn: '',
    updatedOn: '',
  } as unknown as QuickPayMasterProduct,
};

const quickPayMasterProductReducerSlice = createSlice({
  name: 'quickpaymasterProduct',
  initialState,
  reducers: {
    getQuickPayMasterProducts: (
      state,
      action: PayloadAction<IFetchQuickPayMasterProduct>,
    ) => {
      state.loading = true;
    },
    getQuickPayMasterProductsSuccess: (
      state,
      action: PayloadAction<IApiResponse>,
    ) => {
      state.loading = false;
      state.quickPayMasterProducts = { ...action.payload };
    },
    getQuickPayMasterProductsFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
    },
    getQuickPayMasterProduct: (state) => {
      state.loading = true;
    },
    getQuickPayMasterProductSuccess: (
      state,
      action: PayloadAction<QuickPayMasterProduct>,
    ) => {
      state.loading = false;
      state.quickPayMasterProduct = { ...action.payload }; // Avoid direct assignment, create a new object
    },
    getQuickPayMasterProductFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
    },
    createQuickPayMasterProduct: (
      state,
      action: PayloadAction<ICreateQuickPayMasterProduct>,
    ) => {
      state.loading = true;
    },
    createQuickPayMasterProductSuccess: (
      state,
      action: PayloadAction<QuickPayMasterProduct>,
    ) => {
      state.loading = false;
      state.quickPayMasterProduct = { ...action.payload }; // Avoid direct assignment, create a new object
    },
    createQuickPayMasterProductFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
    },
    updateQuickPayMasterProduct: (
      state,
      action: PayloadAction<ICreateQuickPayMasterProduct>,
    ) => {
      state.loading = true;
    },
    updateQuickPayMasterProductSuccess: (
      state,
      action: PayloadAction<QuickPayMasterProduct>,
    ) => {
      state.loading = false;
      state.quickPayMasterProduct = { ...action.payload }; // Avoid direct assignment, create a new object
    },
    updateQuickPayMasterProductFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
    },
    deleteQuickPayMasterProduct: (
      state,
      action: PayloadAction<IDeleteQuickPayMasterProduct>,
    ) => {
      state.loading = true;
    },
    deleteQuickPayMasterProductSuccess: (
      state,
      action: PayloadAction<QuickPayMasterProduct>,
    ) => {
      state.loading = false;
      state = {
        ...state,
        quickPayMasterProducts: {
          ...state.quickPayMasterProducts,
          data: state.quickPayMasterProducts.data.filter(
            (item) => item.productId !== action.payload.productId,
          ),
        },
      }; // Avoid direct assignment, create a new object
    },
    deleteQuickPayMasterProductFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
    },
  },
});

const quickPayMasterProductReducer = quickPayMasterProductReducerSlice.reducer;
export const {
  getQuickPayMasterProducts,
  getQuickPayMasterProductsSuccess,
  getQuickPayMasterProductsFailure,
  getQuickPayMasterProduct,
  getQuickPayMasterProductSuccess,
  getQuickPayMasterProductFailure,
  createQuickPayMasterProduct,
  createQuickPayMasterProductSuccess,
  createQuickPayMasterProductFailure,
  updateQuickPayMasterProduct,
  updateQuickPayMasterProductSuccess,
  updateQuickPayMasterProductFailure,
  deleteQuickPayMasterProduct,
  deleteQuickPayMasterProductSuccess,
  deleteQuickPayMasterProductFailure,
} = quickPayMasterProductReducerSlice.actions;
export default quickPayMasterProductReducer;
